/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThoughtspotLiveboardsCreateResponse
 */
export interface ThoughtspotLiveboardsCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof ThoughtspotLiveboardsCreateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtspotLiveboardsCreateResponse
     */
    name: string;
}

/**
 * Check if a given object implements the ThoughtspotLiveboardsCreateResponse interface.
 */
export function instanceOfThoughtspotLiveboardsCreateResponse(value: object): value is ThoughtspotLiveboardsCreateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ThoughtspotLiveboardsCreateResponseFromJSON(json: any): ThoughtspotLiveboardsCreateResponse {
    return ThoughtspotLiveboardsCreateResponseFromJSONTyped(json, false);
}

export function ThoughtspotLiveboardsCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThoughtspotLiveboardsCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ThoughtspotLiveboardsCreateResponseToJSON(json: any): ThoughtspotLiveboardsCreateResponse {
    return ThoughtspotLiveboardsCreateResponseToJSONTyped(json, false);
}

export function ThoughtspotLiveboardsCreateResponseToJSONTyped(value?: ThoughtspotLiveboardsCreateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

